//imports
import {
    LASTREADING_REQUEST_DETAILS_OPEN_MODAL,
    LASTREADING_REQUEST_DETAILS_REQUEST,
    LASTREADING_REQUEST_DETAILS_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: [],
    data: null,
    total: 0
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LASTREADING_REQUEST_DETAILS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, data: action.payload.data, total: action.payload.total }

        case LASTREADING_REQUEST_DETAILS_REQUEST:
            return { ...state, loading: true }

        case LASTREADING_REQUEST_DETAILS_RESULT:
            return { ...state, loading: false, result: [...state.result, ...action.payload.data] }

        case CLEAR_REDUX:
            return ["", "LASTREADING_REQUEST_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};